module.exports = __webpack_public_path__ + "static/media/anywhere.0dba324d.jpeg";